import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getViewPrItems } from "../../../../../Store/prosafe/proTransaction/PurRequest/getViewPrItems";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import moment from "moment";
import DropDown from "../../../../../Components/DropDown";
import { Pagination, Search } from "../../../Table";
import Swal from "sweetalert2";
import { verifyPr } from "../../../../../Store/Admin/believe/PurchaseRequest/verifyPr";
import { getStatusLabel } from "../../components/ProStatus/StatusFile";
import { pendingPrStatus } from "../../../../../Store/Admin/believe/PurchaseRequest/pendingStatus";

const ReadOnlyInput = ({ label, value }) => (
  <div className="col-12 col-md-4 col-xl-4">
    <div className="input-block local-forms custom-select-wpr">
      <label>{label}</label>
      <input className="form-control" value={value || "-"} readOnly />
    </div>
  </div>
);

const ViewPurRequest = () => {
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const navigate = useNavigate();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);

  useEffect(() => {
    if (data?._id) {
      const formData = {
        id: data?._id,
      };
      dispatch(getViewPrItems({ formData: formData }));
    }
  }, [data]);

  const itemData = useSelector((state) => state?.getViewPrItems?.user?.data);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Request",
      link: "/main-store/user/purchase-request-management",
    },
    { label: "View Purchase Request", active: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = itemData?.items_details;
    if (search) {
      computedComments = computedComments.filter(
        (fi) =>
          fi.party_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
          fi.item_name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, itemData]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleUpdateStatus = async () => {
    Swal.fire({
      title: `Mark ${data?.voucher_no} Status to Pending`,
      text: "Do you want to mark this PR as Pending?",
      showCancelButton: true,
      confirmButtonText: "Pending",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      const id = data?._id;
      if (!result.isConfirmed) return;

      const res = await dispatch(pendingPrStatus(id));
      if (res?.payload?.success) {
        navigate("/main-store/user/purchase-request-management");
      }

      Swal.fire({
        icon: res?.payload?.success ? "success" : "error",
        title: res?.payload?.success ? "Updated!" : "Error",
        text: res?.payload?.message || "",
      });
    });
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12 d-flex justify-content-between">
                      <div className="form-heading ">
                        <h4>View Purchase Request Details</h4>
                      </div>
                      <div>
                        Status:
                        <span className="ms-2">
                          {getStatusLabel(data.status)}
                        </span>
                      </div>
                    </div>

                    <div className="row">
                    <ReadOnlyInput
                        label="Project No"
                        value={data?.manual_pro_no}
                      />
                    <ReadOnlyInput
                        label="Project"
                        value={`${data?.project_details?.name} ${
                          data?.project_details?.project_no
                            ? `(${data?.project_details?.project_no} )`
                            : ""
                        } `}
                      />
                      <ReadOnlyInput
                        label="Drawing No."
                        value={data?.drawing_no?.map((e) => e?.name).join(" ,")}
                      />
                      <ReadOnlyInput label="PR No." value={data?.voucher_no} />
                      <ReadOnlyInput
                        label="PR Date"
                        value={moment(data?.trans_date).format("YYYY-MM-DD")}
                      />
                      <ReadOnlyInput
                        label="Quotation No"
                        value={data?.quotation_details?.voucher_no}
                      />
                      <ReadOnlyInput label="Payment Method." value={data?.payment_method_name} />
                      <ReadOnlyInput
                        label="Expected Delivery Date"
                        value={
                          data?.exp_delivery_date
                            ? moment(data?.exp_delivery_date).format(
                                "YYYY-MM-DD"
                              )
                            : "-"
                        }
                      />
                      <ReadOnlyInput label="Remarks" value={data?.remarks} />
                      <ReadOnlyInput
                        label="Department"
                        value={data?.department_name}
                      />
                      {data?.verify_by?.reject_reason && (
                        <ReadOnlyInput
                          label="Rejected Reason"
                          value={data?.verify_by.reject_reason ?? "-"}
                        />
                      )}
                      {data?.rej_reason && (
                        <ReadOnlyInput
                          label="Admin Rejected Reason"
                          value={data?.rej_reason ?? "-"}
                        />
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="page-table-header mb-2 p-0">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Items List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <Search
                                  onSearch={(value) => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                  }}
                                />
                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                <a className="btn">
                                  <img
                                    src="/assets/img/icons/search-normal.svg"
                                    alt="search"
                                  />
                                </a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                        <DropDown
                          limit={limit}
                          onLimitChange={(val) => setlimit(val)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th>Item No</th>
                          <th>Item Name</th>
                          <th>Party Name</th>
                          <th>PR Qty</th>
                          <th>Original Rate(₹)</th>
                          <th>Purchase Rate(₹)</th>
                          <th>Amount(₹)</th>
                          <th>GST (%)</th>
                          <th>GST Amount(₹)</th>
                          <th>Total Amount(₹)</th>
                          <th>Item Length</th>
                          <th>Item Width</th>
                          <th>Item Weight</th>
                          <th>Item Radius</th>
                          <th>Item Thickness</th>
                          <th>Assembly Weight</th>
                          <th>Surface Area</th>
                          <th>Remarks</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commentsData?.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{index + 1}</td>
                            <td>{item.item_no || "-"}</td>
                            <td>{item.item_name || "-"}</td>
                            <td>{item.party_name || "-"}</td>
                            <td>{item.required_qty || "-"}</td>
                            <td>
                              {item.mrp ? Number(item.mrp).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.rate ? Number(item.rate).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.amount
                                ? Number(item.amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.gst ? Number(item.gst).toFixed(2) : "-"}
                            </td>
                            <td>
                              {item.gst_amount
                                ? Number(item.gst_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>
                              {item.total_amount
                                ? Number(item.total_amount).toFixed(2)
                                : "-"}
                            </td>
                            <td>{item.item_length || "-"}</td>
                            <td>{item.item_width || "-"}</td>
                            <td>{item.item_weight || "-"}</td>
                            <td>{item.item_radius || "-"}</td>
                            <td>{item.item_thickness ?? "-"}</td>
                            <td>{item.assembly_weight || "-"}</td>
                            <td>{item.assembly_surface_area || "-"}</td>
                            <td>{item.remarks || "-"}</td>
                            <td>{item.isAuto ? "Auto" : "Manual"}</td>
                          </tr>
                        ))}
                        {commentsData?.length === 0 ? (
                          <tr>
                            <td colSpan="999">
                              <div className="no-table-data">
                                No Data Found!
                              </div>
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="row align-center mt-3 mb-2">
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_0_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                        data
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="DataTables_Table_0_paginate"
                      >
                        <Pagination
                          total={totalItems}
                          itemsPerPage={limit}
                          currentPage={currentPage}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12">
                    <div className="doctor-submit d-flex justify-content-between">
                      {data?.status === 4 && (
                        <>
                          <div className="d-flex flex-column">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleUpdateStatus}
                              title="This will move the PR back to Pending status."
                            >
                              Reopen PR (Mark as Pending)
                            </button>
                          </div>
                        </>
                      )}
                      <button
                        type="button"
                        className="btn btn-primary submit-form ms-auto me-2"
                        onClick={() =>
                          navigate(
                            "/main-store/user/purchase-request-management"
                          )
                        }
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPurRequest;
